import { SquashMood } from '@src/data/types';

type Props = {
  mood: SquashMood;
  size?: 'small' | 'medium';
};

export const SquashMoodView = ({ mood, size = 'medium' }: Props) => {
  return (
    <div
      className={`flex w-fit items-center justify-center rounded-[200px] text-[16px] ${
        size === 'medium' ? 'px-5 py-1' : 'px-2.5 py-0 text-sm'
      } ${
        mood === 'sad'
          ? 'bg-squashRed-100'
          : mood === 'happy'
          ? 'bg-squashGreen-200'
          : mood === 'thirsty'
          ? 'bg-squashThirsty'
          : 'bg-squashRed-100' // default fallback
      }`}
    >
      {mood}
    </div>
  );
};
